import { ReactNode } from 'react';
import { Box, Button, Dialog, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './styles';
import React from 'react';

interface WarningModalProps {
  open: boolean;
  handleClose?: VoidFunction;
  handleProceed?: () => Promise<void>;
  message: React.ReactNode | string;
  art: ReactNode;
  proceedText?: string;
  closeText?: string;
}

function WarningModal(props: WarningModalProps) {
  const { open, handleClose, handleProceed, message, art, proceedText, closeText } = props;

  return (
    <Dialog open={open} onClose={handleClose} sx={{ minWidth: 0 }}>
      <Box
        sx={{
          display: 'flex',
          flexFlow: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '3.3rem 4.9rem',
          rowGap: '1.65rem',
          position: 'relative'
        }}>
        {handleClose && (
          <Box
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              zIndex: 10, // ensure it's above other content
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#fff', // add background to avoid blending in
              borderRadius: '50%',
              boxShadow: 1,
              width: 40,
              height: 40,
              p: 0
            }}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                color: (theme) => theme.palette.grey[700],
                width: 40,
                height: 40,
                p: 0
              }}
              size="large">
              <CloseIcon sx={{ fontSize: 28 }} />
            </IconButton>
          </Box>
        )}
        {art}
        {typeof message === 'string' ? (
          <Typography variant="h6" sx={{ fontWeight: '500' }}>
            {message}
          </Typography>
        ) : (
          message
        )}
      </Box>
      <Box
        sx={{
          ...styles.bottomRow
        }}>
        {handleClose && closeText && (
          <Button
            sx={{
              typography: 'body1',
              borderRadius: '4px',
              p: '0.5rem 1rem',
              color: 'primary.main',
              width: 'fit-content',
              flex: 1
            }}
            onClick={handleClose}>
            {`${closeText ? `${closeText}` : ''}`}
          </Button>
        )}
        {handleProceed && proceedText && (
          <Button
            variant="outlined"
            sx={{
              typography: 'body1',
              p: '0.8rem 1.5rem', // Increased horizontal padding for more space
              color: 'primary.main',
              minWidth: 0,
              width: '100%',
              border: '1px solid',
              borderRadius: '4px',
              flex: 1,
              whiteSpace: 'nowrap',
              textAlign: 'center'
            }}
            onClick={async () => {
              await handleProceed();
            }}>
            <span style={{ padding: '0 0.5rem' }}>{proceedText ? proceedText : ''}</span>
          </Button>
        )}
      </Box>
    </Dialog>
  );
}

export default WarningModal;
